import React from "react";
import { Experience } from "../types";

interface ExperienceSectionProps {
  experience: Experience[];
}

const ExperienceSection: React.FC<ExperienceSectionProps> = ({
  experience,
}) => {
  return (
    <section className="experience-section section-padding" id="experience">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-10 col-12 mx-auto">
            <div className="section-header text-center mb-5">
              <h2 className="section-title">Professional Experience</h2>
              <p className="section-subtitle">
                My journey through various roles and companies, building
                expertise in software development
              </p>
            </div>
            <div className="experience-timeline">
              {experience.map((job, index) => (
                <div key={index} className="experience-item">
                  <div className="experience-icon">
                    <i className="fas fa-briefcase"></i>
                  </div>
                  <div className="experience-content">
                    <div className="experience-header">
                      <h3 className="job-title">{job.title}</h3>
                      <div className="job-company-info">
                        {job.companyUrl ? (
                          <a
                            href={job.companyUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="job-company"
                            title={`Visit ${job.company} website`}
                          >
                            {job.company}
                            <i
                              className="fas fa-external-link-alt"
                              style={{ marginLeft: "5px", fontSize: "0.8rem" }}
                            ></i>
                          </a>
                        ) : (
                          <span className="job-company">{job.company}</span>
                        )}
                        <div className="job-period">{job.years}</div>
                      </div>
                    </div>
                    <div className="job-description">
                      <ul>
                        {job.description.map((desc, i) => (
                          <li key={i}>{desc}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
